var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCostTurn = function SvgCostTurn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 128,
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cost-turn_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7eb8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cost-turn_svg__a",
    d: "M9.532 29C14.31 12.257 29.724 0 48 0c22.091 0 40 17.909 40 40S70.091 80 48 80c-14.389 0-27.003-7.598-34.05-19h4.806C25.291 70.084 35.955 76 48 76c19.882 0 36-16.118 36-36S67.882 4 48 4C31.954 4 18.36 14.498 13.712 29H24L12 45 0 29z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cost-turn_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#cost-turn_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 47h85v48H17z",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 39h85v48H13z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 43h77v40H17z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 76.083V49.917A6.005 6.005 0 0 0 23.917 45h63.166A6.005 6.005 0 0 0 92 49.917v26.166A6.005 6.005 0 0 0 87.083 81H23.917A6.005 6.005 0 0 0 19 76.083z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 26)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#cost-turn_svg__b)",
    xlinkHref: "#cost-turn_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#33a0ff",
    mask: "url(#cost-turn_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22-26h128v128H-22z"
  }))))));
};
export default SvgCostTurn;